import { useEffect, useState, useRef } from "react";
import { db } from "../firebase/firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { fetchResultsByUser } from "../services/resultService";
import TestInstructions from "../components/TestInstructions";

function HomePage({ user, onStartTest }) {
  const [tests, setTests] = useState({});
  const [expandedTest, setExpandedTest] = useState(null);
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showInstructionsModal, setShowInstructionsModal] = useState(null);
  const [isUserPremium, setIsUserPremium] = useState(false);

  const openInstructionsModal = (e, testId) => {
    e.stopPropagation();
    setShowInstructionsModal(testId);
  };

  const closeInstructionsModal = () => {
    setShowInstructionsModal(null);
  };

  // No need for click outside logic for modal

  const TestGroup1 = [
    { id: "test_1_20", title: "1" },
    { id: "test_2_20", title: "1" },
    { id: "test_3_20", title: "1" }
    // { id: "test_4_5", title: "Test 4 - 5 Questions" },
    // { id: "test_5_5", title: "Test 5 - 5 Questions" }
  ];

  const TestGroup2 = [
    { id: "test_1_20", title: "PMBOK 7 - the hardest test in the series" }
  ];

  useEffect(() => {
    fetchTests();
    fetchResults();
    fetchUserPremiumStatus();
  }, []);

  const fetchTests = async () => {
    const testIds = [
      ...TestGroup1.map(t => t.id),
      ...TestGroup2.map(t => t.id)
    ];

    const fetchedTests = {};
    for (const id of testIds) {
      const docRef = doc(db, "tests", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        fetchedTests[id] = { id: docSnap.id, ...docSnap.data() };
      }
    }
    setTests(fetchedTests);
  };

  const fetchResults = async () => {
    const data = await fetchResultsByUser(user.uid);
    setResults(data);
  };

  const fetchUserPremiumStatus = async () => {
    const docRef = doc(db, "users", user.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setIsUserPremium(docSnap.data().isPremium || false);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setShowDropdown(false);
  };

  const average =
    results.length > 0
      ? Math.round(
          results.reduce((acc, r) => acc + r.percentage, 0) / results.length
        )
      : 0;

  const selectedTestHistory = results
    .filter(r => r.testId === expandedTest?.id)
    .sort((a, b) => {
      const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
      const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
      return dateB - dateA;
    });

  const formatTimeTaken = (seconds) => {
    if (!seconds) return "0 min 0 sec";
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes} min ${secs} sec`;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${month}/${day}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const getScoreDescription = (percentage) => {
    if (percentage < 60) {
      return {
        level: "Needs Improvement",
        status: "Stop. Significant knowledge gaps in core concepts.",
        graphic: "🔴",
        color: "#dc3545"
      };
    } else if (percentage >= 60 && percentage < 70) {
      return {
        level: "Below Target",
        status: "Proceed with Caution. You understand the basics but lack consistency.",
        graphic: "⚠️",
        color: "#ffc107"
      };
    } else if (percentage >= 70 && percentage <= 80) {
      return {
        level: "Target",
        status: "Ready. This is \"safe zone\" for most simulators.",
        graphic: "✅",
        color: "#28a745"
      };
    } else {
      return {
        level: "Above Target",
        status: "🌟 Mastery. Highly likely to pass with a comfortable margin.",
        graphic: "🏆",
        color: "#007bff"
      };
    }
  };

  return (
    <>
      <style>
        {`
           @media (max-width: 768px) {
             .mobile-stack {
               flex-direction: column !important;
               align-items: flex-start !important;
             }
             .mobile-test-card {
               padding: 5px !important;
             }
             .mobile-test-card > div > div[style*="position: absolute"] {
               position: relative !important;
               top: auto !important;
               right: auto !important;
               align-self: flex-end !important;
               margin-bottom: 10px !important;
             }
             .mobile-test-details {
               flex-direction: column !important;
               gap: 8px !important;
               align-items: flex-start !important;
             }
             .mobile-start-btn {
               width: 110px !important;
               margin-top: 0 !important;
               align-self: center !important;
             }
             .mobile-history-table {
               width: 100% !important;
             }
           }
          @media (max-width: 480px) {
            .mobile-test-card {
              padding: 5px !important;
            }
          }
        `}
      </style>
      <div style={{ padding: "5px 0", minHeight: "100vh" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "0 7px" }}>
        <div className="mobile-user-header" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px", marginBottom: 20, position: "relative" }}>
          <span style={{ fontSize: "16px" }}>{user.email}</span>
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            style={{
              padding: "5px 5px",
              background: "#F1F5F9",
              color: "#333",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "18px"
            }}
          >
            👤
          </button>
          {showDropdown && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                right: 0,
                marginTop: "8px",
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                minWidth: "150px",
                zIndex: 10
              }}
            >
              <div
                onClick={handleLogout}
                style={{
                  padding: "10px 16px",
                  cursor: "pointer"
                }}
              >
                Logout
              </div>
            </div>
          )}
        </div>
        <div style={{ marginTop: 0 }}>
          <h3>Welcome to PMP preparation dashboard</h3>
          
          <p>
            Use the practice tests below to strengthen your knowledge, track your progress, and build confidence for the PMP exam. Each test is designed to help you identify your strengths and pinpoint areas that need improvement before the real exam.
          </p>
          <p>
            Your results are saved automatically—including your score, time spent, number of correct answers, and test date—so you can easily monitor your progress over time.
          </p>
          <p>
            After completing a test, you’ll receive a detailed review with your score, a breakdown of correct and incorrect answers, and clear explanations for every question to help you learn and improve with each attempt.
          </p>
          {/* <p>
            Use the test below to practice, test your knowledge, and track your progress toward PMP certification. Tests will help you identify strengths and improve weaker areas before the real exam.
            Your test results will be saved automatically, including score, duration, number of correct answers, and test date, allowing you to monitor your progress over time.
            After completing each test, you'll gain access to a detailed review with your score, correct and incorrect answers, and explanations for each question.
          </p>           */}
        </div>

        <div style={{ marginTop: 40, padding: 5, border: "1px solid #e0e0e0", borderRadius: 10, backgroundColor: "#F1F5F9" }}>
          <h3>Your Overall Stats 📊</h3>
          <p>Attempts: {results.length}</p>
          <p>Average: {average}%</p>
        </div>

        <div style={{ marginTop: 40 }}>
          <h3>PMBOK® GUIDE Seventh Edition</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {TestGroup1.map(testDef => {
              const test = tests[testDef.id];
              if (!test) return null;

              const history = results
                .filter(r => r.testId === test.id)
                .sort((a, b) => {
                  const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
                  const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
                  return dateB - dateA;
                });

              return (
                  <li
                   key={test.id}
                   className="mobile-test-card"
                   style={{
                     marginBottom: 20,
                     padding: 0,      // tofo - override padding for mobile - 20
                     border: "1px solid #ccc",
                     borderRadius: 8,
                     backgroundColor: "white",
                     position: "relative"
                   }}
                 >
                   <div
                     onClick={() => setExpandedTest(expandedTest?.id === test.id ? null : test)}
                     className="mobile-stack"
                     style={{
                       cursor: "pointer",
                       display: "flex",
                       justifyContent: "space-between",
                       alignItems: "flex-start",
                       paddingBottom: "15px"
                     }}
                   >
                       <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                         <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                           <strong>{test.title}</strong>
                         </div>
                         <div className="mobile-test-details" style={{ display: "flex", gap: "20px", alignItems: "center", fontSize: "14px", color: "#475569" }}>
                         <div><strong style={{ color: "#1E293B" }}>Questions:</strong> {test.questionCount || "?"}</div>
                         <div><strong style={{ color: "#1E293B" }}>Difficulty:</strong> {test.difficulty || "Medium"}</div>
                         <div><strong style={{ color: "#1E293B" }}>⏱ Time Limit:</strong> {test.isTimed && test.timeLimit ? `${test.timeLimit} min` : "No limit"}</div>
                       </div>
                     </div>
                     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", position: "absolute", top: "20px", right: "20px" }}>
                       <div className="mobile-action-section" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                         <span
                           style={{
                             fontSize: "18px",
                             color: "#0066CC",
                             cursor: "pointer"
                           }}
                           title="Test instructions"
                           onClick={(e) => openInstructionsModal(e, test.id)}
                         >
                           🛈
                         </span>
                         <img
                           src={test.isFree ? "/img/free-2.svg" : "/img/premium-2.svg"}
                           alt={test.isFree ? "Free" : "Premium"}
                           style={{ width: "24px", height: "24px" }}
                         />
                         <span
                           style={{
                             marginLeft: 4,
                             fontWeight: 500,
                             color: test.isFree ? "#22c55e" : "#f59e42",
                             fontSize: "15px",
                             letterSpacing: 0.5
                           }}
                         >
                           {test.isFree ? "Free" : "Premium"}
                         </span>
                       </div>
                       <div className="mobile-button-section">
                         <button
                             className="mobile-start-btn"
                             style={{
                               padding: "8px 16px",
                               background: test.isFree || isUserPremium ? "#007bff" : "#CBD5E1",
                               color: test.isFree || isUserPremium ? "white" : "#64748B",
                               border: "none",
                               borderRadius: "6px",
                               cursor: test.isFree || isUserPremium ? "pointer" : "not-allowed",
                               fontSize: "14px",
                               width: "110px",
                               flexShrink: 0
                             }}
                             onClick={(e) => {
                               e.stopPropagation();
                               if (test.isFree || isUserPremium) onStartTest(test);
                             }}
                             disabled={!(test.isFree || isUserPremium)}
                           >
                             ▶ Start Test
                           </button>
                       </div>
                     </div>
                   </div>
                   <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                     <span className="mobile-expand-arrow" style={{ fontSize: "20px", cursor: "pointer" }} onClick={() => setExpandedTest(expandedTest?.id === test.id ? null : test)}>▼</span>
                   </div>

                  {/* Modal for instructions */}
                  {showInstructionsModal === test.id && (
                    <div style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      background: "rgba(0,0,0,0.4)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 9999
                    }}>
                      <div style={{
                        background: "white",
                        padding: 32,
                        borderRadius: 12,
                        minWidth: 340,
                        maxWidth: 400,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
                        textAlign: "center"
                      }}>
                        <TestInstructions test={test} />
                        <button
                          style={{
                            marginTop: 24,
                            padding: "8px 32px",
                            background: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: 6,
                            fontSize: 16,
                            cursor: "pointer"
                          }}
                          onClick={closeInstructionsModal}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}

                  {expandedTest?.id === test.id && (
                    <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: 10, paddingBottom: 10, backgroundColor: "#F1F5F9", paddingLeft: 15 }}>
                      <h3 style={{ paddingBottom: 10 }}>Description</h3>

                      {test.description && (
                        <p style={{ marginBottom: 10 }}>
                          {test.description}
                        </p>
                      )}

                      {/* Instructions removed from main view */}

                      <div style={{ marginTop: 20 }}>
                        <h4 style={{ paddingBottom: 10 }}>Your History</h4>
                        {history.length === 0 ? (
                          <p>No attempts yet.</p>
                        ) : (
                          <>
                            {(() => {
                              const highestScoreResult = history.reduce((max, r) =>
                                r.percentage > max.percentage ? r : max
                              , history[0]);
                              const scoreDesc = getScoreDescription(highestScoreResult.percentage);
                              return (
                                <div style={{ marginBottom: 15, padding: 12, border: "1px solid #e0e0e0", borderRadius: 8, backgroundColor: "#f8f9fa" }}>
                                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                    <div style={{ gridColumn: "1 / -1" }}>
                                      <p style={{ margin: 0 }}><strong>Highest: {highestScoreResult.score} / {highestScoreResult.totalQuestions} ({highestScoreResult.percentage}%)</strong></p>
                                    </div>
                                    <div>
                                      <p style={{ fontSize: "14px", margin: 0 }}>Level: {scoreDesc.graphic} {scoreDesc.level}</p>
                                    </div>
                                    <div>
                                      <p style={{ fontSize: "14px", margin: 0 }}>Status: {scoreDesc.status}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                             })()}
                            <table className="mobile-history-table" style={{ width: "60%", borderCollapse: "collapse", fontSize: "14px" }}>
                              <tbody>
                                {history.map(r => (
                                  <tr key={r.id}>
                                    <td style={{ padding: "8px 0" }}>
                                      {r.score}/{r.totalQuestions} ({r.percentage}%)
                                    </td>
                                    <td style={{ padding: "8px 0", textAlign: "right" }}>
                                      ⏱ Time: {formatTimeTaken(r.timeTaken)}
                                    </td>
                                    <td style={{ padding: "8px 0", textAlign: "right", fontSize: "12px", color: "#666" }}>
                                      {formatDate(r.createdAt)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
           </ul>
        </div>
      </div>
    </div>
    </>
  );
}

export default HomePage;
